import {
  normalRingProVariantGid,
  RING_PRO_PRODUCT_ID_US,
  VARIANT_GID_PREFIX,
} from 'content/products/ring-pro/bestBuyPickupVariants';

/** Line attribute that marks a Best Buy pickup ring line (BB_LINE_PROPS.SKU). */
const PICKUP_SKU_ATTRIBUTE = '_bb_pickup_sku';

export const BEST_BUY_PICKUP_ITEM_CATEGORY = 'bestbuy_pickup';
const RING_PRO_ITEM_NAME = 'Ultrahuman Ring PRO';

export type PickupItemOverrides = {
  item_id: string;
  item_name: string;
  item_category2: string;
};

/** A pickup order's ring line sits on the "Best Buy pickup" Shopify product,
 * but reporting should read as the normal Ring PRO: its normal variant id (so
 * GA4 and Meta content_ids match the catalogue) and name, plus item_category2
 * to tell pickup apart. Null for any line that is not a pickup ring line. */
export const pickupItemOverrides = (
  attrs: ReadonlyArray<{ key: string; value: string }>,
): PickupItemOverrides | null => {
  const sku = attrs.find((a) => a.key === PICKUP_SKU_ATTRIBUTE)?.value;
  const gid = sku ? normalRingProVariantGid(sku) : null;
  if (!gid) return null;
  return {
    item_id: gid.replace(VARIANT_GID_PREFIX, ''),
    item_name: RING_PRO_ITEM_NAME,
    item_category2: BEST_BUY_PICKUP_ITEM_CATEGORY,
  };
};

/** Triple Whale's pixel carries only product and variant ids, so a pickup
 * ring line is reported as the normal Ring PRO (pickup orders still show as
 * their own product in Triple Whale's order-based attribution). Null for any
 * line that is not a pickup ring line. */
export const pickupReportingIds = (
  attrs: ReadonlyArray<{ key: string; value: string }> | undefined,
): { variantId: string; productId: string } | null => {
  const overrides = attrs ? pickupItemOverrides(attrs) : null;
  return overrides
    ? { variantId: overrides.item_id, productId: RING_PRO_PRODUCT_ID_US }
    : null;
};
